import React from "react";
import { Flex } from "../../components/Flex";
import { Modal } from "../../components/Modal";
import { VMSLogoSmall } from "../../icons/VMSLogoSmall";
import { Scrollbar } from "../../components/Scrollbar";
import { find } from "lodash";
import { Label, Paragraph, Title } from "../../components/Text";

const AboutModal = ({ visible, onClose, notes=[], selected, onItemSelect, currentVersion }) => {
    const selectedVersion = find(notes, { version: selected }) || {};

    const renderTextBlock = (text, key, sublist) => {
        return (
            <Flex key={`item-block-${key}`} gap={{ right: 8 }}>
                <span>
                    {sublist
                        ? <>&mdash;</>
                        : <>&bull;</>
                    }
                </span>
                <Paragraph key={key} size="13px" lineHeight="22px" style={{ textAlign: "justify" }}>
                    {typeof text === "object"
                        ? <>
                            {text.hasOwnProperty("title")
                                ? <Paragraph size="13px">{text.title}</Paragraph>
                                : null}
                            {text.hasOwnProperty("list")
                                ? text.list.map((listitem, i) => renderTextBlock(listitem, `list-item-${i}`, true))
                                : null}
                        </>
                        : text}
                </Paragraph>
            </Flex>
        );
    };

    const renderVersionInfo = (data) => {
        const fields = [
            { title: "", attr: "note" },
            { title: "what's new", attr: "news" },
            { title: "bug fixes", attr: "bugfixes" },
            { title: "enhancements", attr: "enhancements" }
        ];
        let content = [];
        data && fields.map((field, idx) => {
            if (data.hasOwnProperty(field.attr) && data[field.attr].length) {
                let text = Array.isArray(data[field.attr])
                    ? data[field.attr].map((item, i) => renderTextBlock(item, i))
                    : renderTextBlock(data[field.attr]);
                content.push(
                    <Flex key={`content-block-${idx}`} direction="column" gap={{ bottom: 4 }} >
                        <Label bold>{field.title}</Label>
                        {text}
                    </Flex>
                );
            }
        });

        return(
            <Flex direction="column" gap={{ bottom: 18 }} padding={{ right: "12px" }}>
                {content}
            </Flex>
        );
    };

    return(
        <Modal
            visible={visible}
            onCancel={() => onClose()}
            style={{ padding: 0 }}
        >
            <Flex height="400px">
                <Flex direction="column" background="#344E77"  style={{ borderRadius: "16px 0 0 16px" }} padding={{ bottom: "18px" }}>
                    <Flex padding={{ top: "20px", right: "25px", bottom: "18px", left: "20px" }}>
                        <VMSLogoSmall />
                    </Flex>
                    <Flex flex={1}>
                        <Scrollbar>
                            {notes.map(note => note.version).reverse().map(version =>
                                <Flex
                                    key={version}
                                    height="44px"
                                    padding={{ left: "20px", right: "25px" }}
                                    align="center"
                                    justify="space-between"
                                    background={version === selected && "white"}
                                    onClick={() => onItemSelect(version)}
                                    style={{ cursor: "pointer" }}
                                >
                                    <Paragraph size="13px" bold color={version !== selected ? "white" : undefined}>V{version}</Paragraph>
                                    {version == currentVersion && <Label size="10px" filled style={{ textTransform: "none"}}>latest</Label>}
                                </Flex>
                            )}
                        </Scrollbar>
                    </Flex>
                </Flex>
                <Flex flex={1} direction="column" padding={{ top: "20px", right: "13px", bottom: "18px", left: "25px" }}>
                    <Label bold style={{ textTransform: "none"}}>{selectedVersion.date}</Label>
                    <Title h5 style={{marginBottom: "13px" }}>Service Platform v{selectedVersion.version}</Title>
                    <Flex flex={1}>
                        <Scrollbar>
                        {selectedVersion.date
                            ? renderVersionInfo(selectedVersion)
                            : <Paragraph>This version is currently under development.</Paragraph>
                        }
                        </Scrollbar>
                    </Flex>
                </Flex>
            </Flex>
        </Modal>
    )
};

export { AboutModal }